import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';
export { axios };

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401: try to refresh token once, then give up
let isRefreshing = false;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const store = useAuthStore.getState();

    // Only attempt refresh if we have a token, it's a 401, and we haven't retried
    if (
      error.response?.status === 401 &&
      store.accessToken &&
      !originalRequest._retry &&
      !originalRequest.url?.includes('/auth/')
    ) {
      if (isRefreshing) return Promise.reject(error);

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const { data } = await axios.post('/api/auth/refresh', {
          refreshToken: store.refreshToken,
        });
        if (data?.data?.accessToken) {
          store.setAccessToken(data.data.accessToken);
          store.setRefreshToken(data.data.refreshToken);
          originalRequest.headers.Authorization = `Bearer ${data.data.accessToken}`;
          isRefreshing = false;
          return api(originalRequest);
        }
      } catch {
        // Refresh failed — session expired
      }
      isRefreshing = false;
      store.logout();
    }

    return Promise.reject(error);
  },
);

export default api;
